require("core-js/modules/es.array.reduce");

var _defineProperty = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/defineProperty");

var _inherits = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _toConsumableArray = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/createClass");

var _asyncGeneratorDelegate = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/mattk/Desktop/Terranova/terranova-site/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("prop-types"));else if ("function" == typeof define && define.amd) define(["react", "prop-types"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("prop-types")) : t(e.React, e.PropTypes);

    for (var o in n) {
      ("object" == typeof exports ? exports : e)[o] = n[o];
    }
  }
}(this, function (e, t) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 17);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var o;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function r() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];

          if (o) {
            var i = typeof o;
            if ("string" === i || "number" === i) e.push(this && this[o] || o);else if (Array.isArray(o)) e.push(r.apply(this, o));else if ("object" === i) for (var a in o) {
              n.call(o, a) && o[a] && e.push(this && this[a] || a);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (r.default = r, e.exports = r) : void 0 === (o = function () {
        return r;
      }.apply(t, [])) || (e.exports = o);
    }();
  }, function (e, t, n) {
    e.exports = {
      "file-grid": "file-grid--1BGOO",
      "file-grid--row": "file-grid--row--Da16I",
      "file-grid--column": "file-grid--column--2Otzt"
    };
  }, function (e, t, n) {
    e.exports = {
      "file-grid-item": "file-grid-item--_0fiq",
      "file-grid-item_inner": "file-grid-item_inner--1MCIk",
      "file-grid-item_icon": "file-grid-item_icon--1GOHW",
      "file-grid-item_label": "file-grid-item_label--3FSa2",
      "file-grid-item--light": "file-grid-item--light--e24lp",
      "file-grid-item--dark": "file-grid-item--dark--3xDRl"
    };
  }, function (e, t, n) {
    e.exports = {
      desktop: "desktop--2U5pg",
      desktop_items: "desktop_items--3tDWi",
      desktop_background: "desktop_background--11u5_"
    };
  }, function (e, t, n) {
    e.exports = {
      taskbar: "taskbar--Ap6Iu"
    };
  }, function (e, t, n) {
    e.exports = {
      "taskbar-button": "taskbar-button--MzJmj",
      "taskbar-button--borderless": "taskbar-button--borderless--f8oH7",
      "taskbar-button--active": "taskbar-button--active--2SrnT"
    };
  }, function (e, t, n) {
    e.exports = {
      "window-manager": "window-manager--KrBjA",
      "window-manager_layer-group": "window-manager_layer-group--Yt68A",
      "window-manager_layer": "window-manager_layer--YHnOX"
    };
  }, function (e, t, n) {
    var o;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function r() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];

          if (o) {
            var i = typeof o;
            if ("string" === i || "number" === i) e.push(o);else if (Array.isArray(o) && o.length) {
              var a = r.apply(null, o);
              a && e.push(a);
            } else if ("object" === i) for (var s in o) {
              n.call(o, s) && o[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (r.default = r, e.exports = r) : void 0 === (o = function () {
        return r;
      }.apply(t, [])) || (e.exports = o);
    }();
  }, function (e, t, n) {
    e.exports = {
      bsod: "bsod--1H_0P",
      bsod_column: "bsod_column--4A5cn"
    };
  }, function (e, t, n) {
    e.exports = {
      window: "window--13ujq",
      "window--focused": "window--focused--2-nSM",
      window_header: "window_header--1A5sM",
      window_title: "window_title--DWigu",
      window_buttons: "window_buttons--2k5ol",
      window_body: "window_body--2TbKa",
      "window-button": "window-button--2A-WI",
      "window-button--close": "window-button--close--X4miR"
    };
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00LDEyKSI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0yMCwxNEg0VjEwSDIwIiAvPgogICA8L2c+Cjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xOSw2LjQxTDE3LjU5LDVMMTIsMTAuNTlMNi40MSw1TDUsNi40MUwxMC41OSwxMkw1LDE3LjU5TDYuNDEsMTlMMTIsMTMuNDFMMTcuNTksMTlMMTksMTcuNTlMMTMuNDEsMTJMMTksNi40MVoiIC8+Cjwvc3ZnPg==";
  }, function (e, t, n) {
    e.exports = {
      outline: "outline--7Bks2",
      "outline--animate": "outline--animate--PlkLC"
    };
  }, function (e, t, n) {
    e.exports = {
      "window-frame": "window-frame--1e6t8",
      "window-frame_shadow": "window-frame_shadow--3vWl4",
      "appear--enter": "appear--enter--OGbDx",
      "appear--enter-active": "appear--enter-active--Z7uiF",
      "appear--enter-done": "appear--enter-done--2Vnuw"
    };
  }, function (e, t, n) {
    e.exports = {
      "file-grid-item": "file-grid-item--AGvUH",
      "file-grid-item_origin": "file-grid-item_origin--2YABG"
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "WindowManager", function () {
      return Ce;
    }), n.d(t, "WMWindow", function () {
      return je;
    }), n.d(t, "WMTaskbarButton", function () {
      return xe;
    }), n.d(t, "WMFileGridItem", function () {
      return Re;
    }), n.d(t, "useWindowState", function () {
      return Ue;
    }), n.d(t, "useWMWindowState", function () {
      return Ue;
    }), n.d(t, "useWMWindowElement", function () {
      return ke;
    }), n.d(t, "WMFileGrid", function () {
      return p;
    }), n.d(t, "WMAnimationContainer", function () {
      return Z;
    }), n.d(t, "BSOD", function () {
      return J;
    }), n.d(t, "BSODErrorBoundary", function () {
      return X;
    });
    var o = n(0),
        r = n.n(o),
        i = n(1),
        a = n.n(i),
        s = n(3),
        c = n.n(s),
        u = n(2),
        d = n.n(u);

    var l = d.a.bind(c.a),
        m = Object(o.createContext)(),
        p = function p(_ref6) {
      var e = _ref6.children,
          t = _ref6.layout,
          n = _ref6.color;
      return r.a.createElement(m.Provider, {
        value: n
      }, r.a.createElement("div", {
        className: l("file-grid", {
          "file-grid--row": "row" === t,
          "file-grid--column": "column" === t
        })
      }, e));
    };

    p.propTypes = {
      children: a.a.node,
      layout: a.a.oneOf(["row", "column"]),
      color: a.a.oneOf(["light", "dark"])
    }, p.defaultProps = {
      layout: "row",
      color: "dark"
    };
    var w = n(4),
        b = n.n(w);

    var f = d.a.bind(b.a),
        g = function g(_ref7) {
      var e = _ref7.onDoubleClick,
          t = _ref7.icon,
          n = _ref7.label;
      var i = Object(o.useContext)(m);
      return r.a.createElement("button", {
        className: f("file-grid-item", {
          "file-grid-item--light": "light" === i,
          "file-grid-item--dark": "dark" === i
        }),
        onDoubleClick: e,
        onKeyDown: function onKeyDown(t) {
          "Enter" === t.key && e(t);
        }
      }, r.a.createElement("div", {
        className: f("file-grid-item_inner")
      }, r.a.createElement("img", {
        className: f("file-grid-item_icon"),
        src: t,
        draggable: "false"
      }), r.a.createElement("span", {
        className: f("file-grid-item_label")
      }, n)));
    };

    g.propTypes = {
      onDoubleClick: a.a.func,
      icon: a.a.string,
      label: a.a.node
    };
    var v = n(5),
        y = n.n(v);

    var E = d.a.bind(y.a),
        h = function h(_ref8) {
      var e = _ref8.background,
          t = _ref8.children;
      return r.a.createElement("div", {
        className: E("desktop")
      }, r.a.createElement("div", {
        className: E("desktop_background"),
        style: {
          backgroundImage: "url(".concat(e, ")")
        }
      }), t);
    };

    var M = n(6),
        k = n.n(M);

    var j = d.a.bind(k.a),
        x = function x(_ref9) {
      var e = _ref9.children;
      return r.a.createElement("div", {
        className: j("taskbar")
      }, e);
    };

    var O = n(7),
        C = n.n(O);

    var D = d.a.bind(C.a),
        I = function I(_ref10) {
      var e = _ref10.name,
          t = _ref10.active,
          n = _ref10.borderless,
          o = _ref10.children,
          i = _ref10.disabled,
          a = _ref10.onClick,
          s = _ref10.onMouseDown,
          c = _ref10.onMouseUp,
          u = _ref10.onMouseLeave,
          d = _ref10.onKeyDown,
          l = _ref10.onKeyUp,
          m = _ref10.onFocus,
          p = _ref10.onBlur;
      return r.a.createElement("button", {
        name: e,
        className: D("taskbar-button", {
          "taskbar-button--active": t,
          "taskbar-button--borderless": n
        }),
        disabled: i,
        onClick: a,
        onMouseDown: s,
        onMouseUp: c,
        onMouseLeave: u,
        onKeyDown: d,
        onKeyUp: l,
        onFocus: m,
        onBlur: p
      }, o);
    };

    I.propTypes = {
      name: a.a.string,
      active: a.a.bool,
      borderless: a.a.bool,
      children: a.a.node.isRequired,
      disabled: a.a.bool,
      onClick: a.a.func,
      onMouseDown: a.a.func,
      onMouseUp: a.a.func,
      onMouseLeave: a.a.func,
      onKeyDown: a.a.func,
      onKeyUp: a.a.func,
      onFocus: a.a.func,
      onBlur: a.a.func
    };

    var N = n(8),
        _ = n.n(N);

    var R = d.a.bind(_.a),
        L = function L(_ref11) {
      var e = _ref11.background,
          t = _ref11.windowItems,
          n = _ref11.desktopItems,
          o = _ref11.taskbarItems,
          i = _ref11.taskbarExtras;
      return r.a.createElement("div", {
        className: R("window-manager")
      }, r.a.createElement("div", {
        className: R("window-manager_layer-group")
      }, r.a.createElement("div", {
        className: R("window-manager_layer")
      }, r.a.createElement(h, {
        background: e
      }, r.a.createElement(p, {
        layout: "column",
        color: "light"
      }, n))), r.a.createElement("div", {
        className: R("window-manager_layer")
      }, t)), r.a.createElement(x, null, o, i));
    };

    var S = /*#__PURE__*/function () {
      function S() {
        var _this = this;

        _classCallCheck(this, S);

        this._promise = new Promise(function (e) {
          _this._resolve = e;
        });
      }

      _createClass(S, [{
        key: "resolve",
        value: function resolve() {
          this._resolve.apply(this, arguments);
        }
      }, {
        key: "then",
        value: function then() {
          var _this$_promise;

          return (_this$_promise = this._promise).then.apply(_this$_promise, arguments);
        }
      }, {
        key: "catch",
        value: function _catch() {
          var _this$_promise2;

          return (_this$_promise2 = this._promise).catch.apply(_this$_promise2, arguments);
        }
      }], [{
        key: "create",
        value: function create() {
          return new S();
        }
      }]);

      return S;
    }();

    var T = S.create;

    var W = function W() {
      return new Promise(function (e) {
        return window.requestAnimationFrame(e);
      });
    };

    var A = /*#__PURE__*/function () {
      function A() {
        _classCallCheck(this, A);

        this.map = new Map();
      }

      _createClass(A, [{
        key: "ensureKey",
        value: function ensureKey(e) {
          return this.map.has(e) || this.map.set(e, T()), this.map.get(e);
        }
      }, {
        key: "get",
        value: function () {
          var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", Promise.race([this.ensureKey(e), W().then(function () {
                      return !1;
                    })]));

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function get(_x4) {
            return _get.apply(this, arguments);
          }

          return get;
        }()
      }, {
        key: "set",
        value: function () {
          var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    this.ensureKey(e).resolve(t);
                    _context2.next = 3;
                    return W();

                  case 3:
                    this.map.delete(e);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function set(_x5, _x6) {
            return _set.apply(this, arguments);
          }

          return set;
        }()
      }]);

      return A;
    }();

    var z = /*#__PURE__*/function () {
      function z() {
        _classCallCheck(this, z);

        this.inMap = new A(), this.outMap = new A();
      }

      _createClass(z, [{
        key: "in",
        value: function () {
          var _in2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", (this.inMap.set(e, t), this.outMap.get(e)));

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          function _in(_x7, _x8) {
            return _in2.apply(this, arguments);
          }

          return _in;
        }()
      }, {
        key: "out",
        value: function () {
          var _out = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", (this.outMap.set(e, t), this.inMap.get(e)));

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function out(_x9, _x10) {
            return _out.apply(this, arguments);
          }

          return out;
        }()
      }], [{
        key: "create",
        value: function create() {
          return new z();
        }
      }]);

      return z;
    }();

    var F = z.create,
        P = r.a.createContext(),
        Z = function Z(_ref12) {
      var e = _ref12.children;

      var _Object = Object(o.useState)(F),
          _Object2 = _slicedToArray(_Object, 1),
          t = _Object2[0];

      return r.a.createElement(P.Provider, {
        value: t
      }, e);
    },
        B = function B(e, t, n, r) {
      Object(o.useLayoutEffect)(function () {
        return t ? n(e.current) : r(e.current);
      }, [t]);
    };

    var H = n(9),
        G = n.n(H);

    var U = function U(e) {
      return function () {
        var n = e.apply(void 0, arguments);
        var o = !1;
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _e2;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _context5.prev = 2;
                  _iterator = _asyncIterator(n);

                case 4:
                  _context5.next = 6;
                  return _iterator.next();

                case 6:
                  _step = _context5.sent;
                  _iteratorNormalCompletion = _step.done;
                  _context5.next = 10;
                  return _step.value;

                case 10:
                  _value = _context5.sent;

                  if (_iteratorNormalCompletion) {
                    _context5.next = 18;
                    break;
                  }

                  _e2 = _value;

                  if (!o) {
                    _context5.next = 15;
                    break;
                  }

                  return _context5.abrupt("break", 18);

                case 15:
                  _iteratorNormalCompletion = true;
                  _context5.next = 4;
                  break;

                case 18:
                  _context5.next = 24;
                  break;

                case 20:
                  _context5.prev = 20;
                  _context5.t0 = _context5["catch"](2);
                  _didIteratorError = true;
                  _iteratorError = _context5.t0;

                case 24:
                  _context5.prev = 24;
                  _context5.prev = 25;

                  if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                    _context5.next = 29;
                    break;
                  }

                  _context5.next = 29;
                  return _iterator.return();

                case 29:
                  _context5.prev = 29;

                  if (!_didIteratorError) {
                    _context5.next = 32;
                    break;
                  }

                  throw _iteratorError;

                case 32:
                  return _context5.finish(29);

                case 33:
                  return _context5.finish(24);

                case 34:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[2, 20, 24, 34], [25,, 29, 33]]);
        }))(), function () {
          o = !0;
        };
      };
    };

    var K = function K(e) {
      var _Object3 = Object(o.useState)([]),
          _Object4 = _slicedToArray(_Object3, 2),
          t = _Object4[0],
          n = _Object4[1];

      var r;
      return [t, U((r = {
        setup: function setup() {
          return n([e]);
        },
        run: function run() {
          return n([e, e + "-active"]);
        },
        teardown: function teardown() {
          return n([e, e + "-done"]);
        }
      }, /*#__PURE__*/function () {
        var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  r.setup();
                  _context6.next = 3;
                  return W();

                case 3:
                  r.run();
                  _context6.next = 6;
                  return new Promise(function (t) {
                    return e.addEventListener("transitionend", t, {
                      once: !0
                    });
                  });

                case 6:
                  r.teardown();

                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()))];
    },
        V = function V(e, t, n) {
      var _K = K("enter"),
          _K2 = _slicedToArray(_K, 2),
          o = _K2[0],
          r = _K2[1],
          _K3 = K("exit"),
          _K4 = _slicedToArray(_K3, 2),
          i = _K4[0],
          a = _K4[1];

      return B(e, t, r, a), function (e, t) {
        return G()(e.map(function (e) {
          return t[e];
        }));
      }([].concat(_toConsumableArray(o), _toConsumableArray(i)), n);
    };

    var Y = n(10),
        q = n.n(Y);

    var Q = d.a.bind(q.a),
        J = function J(_ref14) {
      var e = _ref14.error;
      return r.a.createElement("div", {
        className: Q("bsod")
      }, r.a.createElement("div", {
        className: Q("bsod_column")
      }, r.a.createElement("h2", null, "Error"), r.a.createElement("pre", null, "An exception has occurred and the application cannot continue"), r.a.createElement("pre", null, e && e.stack)));
    };

    var X = /*#__PURE__*/function (_o$Component) {
      _inherits(X, _o$Component);

      var _super = _createSuper(X);

      function X(e) {
        var _this2;

        _classCallCheck(this, X);

        _this2 = _super.call(this, e), _this2.state = {
          error: null
        };
        return _this2;
      }

      _createClass(X, [{
        key: "render",
        value: function render() {
          var e = this.props.children,
              t = this.state.error;
          return t ? r.a.createElement(J, {
            error: t
          }) : e;
        }
      }], [{
        key: "getDerivedStateFromError",
        value: function getDerivedStateFromError(e) {
          return {
            error: e
          };
        }
      }]);

      return X;
    }(o.Component);

    var $ = {
      left: 0,
      top: 0
    },
        ee = function ee() {};

    var te = n(11),
        ne = n.n(te),
        oe = n(12),
        re = n.n(oe),
        ie = n(13),
        ae = n.n(ie);

    var se = d.a.bind(ne.a),
        ce = function ce(_ref15) {
      var e = _ref15.title,
          t = _ref15.children,
          n = _ref15.className,
          i = _ref15.isFocused,
          a = _ref15.onMinimize,
          s = _ref15.onClose,
          c = _ref15.onDragStart,
          u = _ref15.onDrag,
          d = _ref15.onDragEnd;

      var l = function (_ref16) {
        var _ref16$onDragStart = _ref16.onDragStart,
            e = _ref16$onDragStart === void 0 ? ee : _ref16$onDragStart,
            _ref16$onDrag = _ref16.onDrag,
            t = _ref16$onDrag === void 0 ? ee : _ref16$onDrag,
            _ref16$onDragEnd = _ref16.onDragEnd,
            n = _ref16$onDragEnd === void 0 ? ee : _ref16$onDragEnd;

        var _Object5 = Object(o.useState)($),
            _Object6 = _slicedToArray(_Object5, 2),
            r = _Object6[0],
            i = _Object6[1],
            _Object7 = Object(o.useState)(!1),
            _Object8 = _slicedToArray(_Object7, 2),
            a = _Object8[0],
            s = _Object8[1],
            c = Object(o.useCallback)(function (_ref17) {
          var t = _ref17.clientX,
              n = _ref17.clientY,
              o = _ref17.button;
          2 !== o && (s(!0), i({
            left: t,
            top: n
          }), e());
        }, []),
            u = Object(o.useCallback)(function (_ref18) {
          var e = _ref18.clientX,
              n = _ref18.clientY;
          var o = {
            left: e - r.left,
            top: n - r.top
          };
          t(o);
        }, [r, t]),
            d = Object(o.useCallback)(function () {
          s(!1), n();
        }, [n]);

        return Object(o.useEffect)(function () {
          if (a) return window.addEventListener("mousemove", u), window.addEventListener("mouseup", d), function () {
            window.removeEventListener("mousemove", u), window.removeEventListener("mouseup", d);
          };
        }, [a, u, d]), c;
      }({
        onDragStart: c,
        onDrag: u,
        onDragEnd: d
      });

      return r.a.createElement("div", {
        className: se(n, "window", {
          "window--focused": i
        })
      }, r.a.createElement("div", {
        className: se("window_header"),
        onMouseDown: l
      }, r.a.createElement("span", {
        className: se("window_title")
      }, e), r.a.createElement("div", {
        className: se("window_buttons")
      }, r.a.createElement("button", {
        onClick: a,
        className: se("window-button", "window-button--minimize"),
        name: "minimize window"
      }, r.a.createElement("img", {
        src: re.a,
        alt: ""
      })), r.a.createElement("button", {
        onClick: s,
        className: se("window-button", "window-button--close"),
        name: "close window"
      }, r.a.createElement("img", {
        src: ae.a,
        alt: ""
      })))), r.a.createElement("div", {
        className: se("window_body")
      }, t));
    };

    var ue = n(14),
        de = n.n(ue);
    var le = d.a.bind(de.a),
        me = Object(o.forwardRef)(function (_ref19, n) {
      var e = _ref19.animate,
          t = _ref19.rect;
      var o = {
        top: t.top,
        left: t.left,
        bottom: t.bottom,
        right: t.right
      },
          i = le("outline", {
        "outline--animate": e
      });
      return r.a.createElement("div", {
        ref: n,
        className: i,
        style: o
      });
    });
    me.propTypes = {
      animate: a.a.bool,
      rect: a.a.shape({
        top: a.a.number.isRequired,
        left: a.a.number.isRequired,
        bottom: a.a.number.isRequired,
        right: a.a.number.isRequired
      }).isRequired
    };

    var pe = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    },
        we = function we(e, t) {
      return {
        top: e.top - t.top,
        left: e.left - t.left,
        bottom: -(e.bottom - t.bottom),
        right: -(e.right - t.right)
      };
    },
        be = /*#__PURE__*/function () {
      var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function be() {
        return _ref2.apply(this, arguments);
      };
    }(),
        fe = function fe(e, t) {
      var _Object9 = Object(o.useState)(pe),
          _Object10 = _slicedToArray(_Object9, 2),
          n = _Object10[0],
          r = _Object10[1],
          _Object11 = Object(o.useState)(!1),
          _Object12 = _slicedToArray(_Object11, 2),
          i = _Object12[0],
          a = _Object12[1];

      return function (e, t, n, r, i) {
        var a = Object(o.useContext)(P);
        B(t, n, U( /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var n;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return _awaitAsyncGenerator(a.in(e, t.current));

                case 2:
                  n = _context8.sent;
                  _context8.next = 5;
                  return;

                case 5:
                  _context8.t0 = n;

                  if (!_context8.t0) {
                    _context8.next = 8;
                    break;
                  }

                  return _context8.delegateYield(_asyncGeneratorDelegate(_asyncIterator(r(n, t.current)), _awaitAsyncGenerator), "t1", 8);

                case 8:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }))), U( /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
          var n;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _awaitAsyncGenerator(a.out(e, t.current));

                case 2:
                  n = _context9.sent;
                  _context9.next = 5;
                  return;

                case 5:
                  _context9.t0 = n;

                  if (!_context9.t0) {
                    _context9.next = 8;
                    break;
                  }

                  return _context9.delegateYield(_asyncGeneratorDelegate(_asyncIterator(i(t.current, n)), _awaitAsyncGenerator), "t1", 8);

                case 8:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        })))), Object(o.useEffect)(function () {
          return function () {
            a.out(e, function (e) {
              var t = e.getBoundingClientRect();
              return {
                getBoundingClientRect: function getBoundingClientRect() {
                  return t;
                }
              };
            }(t.current));
          };
        }, []);
      }(e, t, !0, function (e) {
        return /*#__PURE__*/function () {
          var _ref5 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, n) {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    e.setup(t, n);
                    _context10.next = 3;
                    return _awaitAsyncGenerator(W());

                  case 3:
                    _context10.next = 5;
                    return;

                  case 5:
                    e.run(t, n);
                    _context10.next = 8;
                    return _awaitAsyncGenerator(new Promise(function (e) {
                      return n.addEventListener("transitionend", e);
                    }));

                  case 8:
                    _context10.next = 10;
                    return;

                  case 10:
                    e.teardown(t, n);

                  case 11:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          }));

          return function (_x2, _x3) {
            return _ref5.apply(this, arguments);
          };
        }();
      }({
        setup: function setup(e, t) {
          r(function (e, t) {
            var n = e.getBoundingClientRect(),
                o = t.getBoundingClientRect();
            return we(n, o);
          }(e, t)), a(!1);
        },
        run: function run() {
          r(pe), a(!0);
        },
        teardown: function teardown() {
          a(!1);
        }
      }), be), {
        rect: n,
        isAnimating: i
      };
    },
        ge = function ge(_ref20) {
      var e = _ref20.id;

      var t = Object(o.useRef)(),
          _fe = fe(e, t),
          n = _fe.isAnimating,
          i = _fe.rect;

      return r.a.createElement(me, {
        ref: t,
        rect: i,
        animate: n
      });
    };

    var ve = n(15),
        ye = n.n(ve);

    var Ee = d.a.bind(ye.a),
        he = {
      enter: Ee("appear--enter"),
      "enter-active": Ee("appear--enter-active"),
      "enter-done": Ee("appear--enter-done")
    },
        Me = Object(o.createContext)(),
        ke = function ke() {
      return Object(o.useContext)(Me);
    },
        je = function je(_ref21) {
      var e = _ref21.id,
          t = _ref21.title,
          n = _ref21.children,
          i = _ref21.order,
          a = _ref21.position,
          s = _ref21.dimensions,
          c = _ref21.isFocused,
          u = _ref21.onMinimize,
          d = _ref21.onClose,
          l = _ref21.onFocus,
          m = _ref21.onBlur,
          p = _ref21.onMove;
      var w = Object(o.useRef)(),
          b = V(w, !0, he),
          f = Object(o.useRef)();

      (function (e, _ref22) {
        var t = _ref22.isFocused,
            n = _ref22.onFocus,
            r = _ref22.onBlur;
        var i = Object(o.useRef)();
        i.current = t, Object(o.useEffect)(function () {
          t && !e.current.contains(document.activeElement) && e.current.focus({
            preventScroll: !0
          });
        }, [t]), Object(o.useEffect)(function () {
          var t = function t() {
            window.setTimeout(function () {
              var t = e.current && e.current.contains(document.activeElement) || e.current === document.activeElement,
                  o = i.current;
              o && !t && r(), !o && t && n();
            }, 0);
          };

          return document.addEventListener("focusout", t), document.addEventListener("focusin", t), function () {
            document.removeEventListener("focusout", t), document.removeEventListener("focusin", t);
          };
        }, []);
      })(f, {
        isFocused: c,
        onFocus: l,
        onBlur: m
      });

      var _ref23 = function (e, t) {
        var n = Object(o.useRef)(),
            r = Object(o.useRef)();
        n.current = e;

        var _Object13 = Object(o.useState)(!1),
            _Object14 = _slicedToArray(_Object13, 2),
            i = _Object14[0],
            a = _Object14[1];

        return {
          isDragging: i,
          onDragStart: Object(o.useCallback)(function () {
            r.current = n.current, a(!0);
          }, []),
          onDrag: Object(o.useCallback)(function (e) {
            var n = {
              top: r.current.top + e.top,
              left: r.current.left + e.left
            };
            t(n);
          }, [t]),
          onDragEnd: Object(o.useCallback)(function () {
            a(!1);
          }, [])
        };
      }(a, p),
          g = _ref23.onDragStart,
          v = _ref23.onDrag,
          y = _ref23.onDragEnd,
          E = _objectSpread(_objectSpread({
        zIndex: i
      }, a), s);

      return r.a.createElement(Me.Provider, {
        value: f
      }, r.a.createElement("div", {
        className: Ee("window-frame"),
        style: E,
        ref: f,
        tabIndex: "0"
      }, r.a.createElement(ce, {
        className: b,
        title: t,
        isFocused: c,
        onMinimize: u,
        onClose: d,
        onDragStart: g,
        onDrag: v,
        onDragEnd: y
      }, n), r.a.createElement(ge, {
        id: e
      }), r.a.createElement("div", {
        ref: w,
        className: Ee("window-frame_shadow", b)
      })));
    },
        xe = function xe(_ref24) {
      var e = _ref24.id,
          t = _ref24.active,
          n = _ref24.hasOutline,
          o = _ref24.onClick,
          i = _ref24.children;
      return r.a.createElement(I, {
        active: t,
        onClick: o
      }, i, n && r.a.createElement(ge, {
        id: e
      }));
    },
        Oe = Object(o.createContext)(),
        Ce = function Ce(_ref25) {
      var e = _ref25.background,
          t = _ref25.windows,
          n = _ref25.desktopItems,
          o = _ref25.taskbarExtras;
      var i = t.map(function (_ref26) {
        var e = _ref26.id,
            t = _ref26.title,
            n = _ref26.content,
            o = _ref26.state,
            i = _ref26.actions;
        return "open" === o.visibility && r.a.createElement(je, {
          key: e,
          id: e,
          title: t,
          order: o.order,
          position: o.position,
          dimensions: o.dimensions,
          isFocused: o.isFocused,
          onMinimize: i.minimize,
          onClose: i.close,
          onFocus: i.focus,
          onBlur: i.blur,
          onMove: i.move
        }, n);
      }),
          a = t.map(function (_ref27) {
        var e = _ref27.id,
            n = _ref27.title,
            o = _ref27.state,
            i = _ref27.actions;
        return "closed" !== o.visibility && r.a.createElement(xe, {
          key: e,
          id: e,
          active: "open" === o.visibility && o.isFocused,
          hasOutline: "minimized" === o.visibility,
          onClick: "open" === o.visibility && o.order === t.length ? i.minimize : i.open
        }, n);
      });
      return r.a.createElement(X, null, r.a.createElement(Z, null, r.a.createElement(Oe.Provider, {
        value: t
      }, r.a.createElement(L, {
        background: e,
        desktopItems: n,
        windowItems: i,
        taskbarItems: a,
        taskbarExtras: o
      }))));
    };

    var De = n(16),
        Ie = n.n(De);

    var Ne = d.a.bind(Ie.a),
        _e = {
      state: {}
    },
        Re = function Re(_ref28) {
      var e = _ref28.icon,
          t = _ref28.label,
          n = _ref28.id,
          i = _ref28.onDoubleClick;

      var a = "closed" === (Object(o.useContext)(Oe).find(function (e) {
        return e.id === n;
      }) || _e).state.visibility;

      return r.a.createElement("div", {
        className: Ne("file-grid-item")
      }, r.a.createElement(g, {
        icon: e,
        label: t,
        onDoubleClick: i
      }), r.a.createElement("div", {
        className: Ne("file-grid-item_origin")
      }, a && r.a.createElement(ge, {
        id: n
      })));
    },
        Le = {
      get: function get(e) {
        return e;
      },
      set: function set(e, t) {
        return t;
      },
      name: "id"
    },
        Se = function Se(e, t) {
      return {
        get: function get(n) {
          return t.get(e.get(n));
        },
        set: function set(n, o) {
          var r = e.get(n);
          return e.set(n, t.set(r, o));
        },
        name: "".concat(e.name, " ").concat(t.name)
      };
    },
        Te = function Te() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      var t = e.map(function (e) {
        return "number" == typeof e ? {
          get: function get(e) {
            return e[n];
          },
          set: function set(e, t) {
            var o = _toConsumableArray(e);

            return o[n] = t, o;
          },
          name: "[".concat(n = e, "]")
        } : {
          get: function get(e) {
            return e[t];
          },
          set: function set(e, n) {
            return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
          },
          name: "." + (t = e)
        };
        var t, n;
      }).reduce(Se, Le);
      return o = void 0, {
        get: function get(e) {
          try {
            return n.get(e);
          } catch (e) {
            return o;
          }
        },
        set: (n = t).set,
        name: "safe(".concat(n.name, ")")
      };
      var n, o;
    },
        We = function We(e, t) {
      return function (n) {
        return e.set(n, t(e.get(n)));
      };
    };

    var Ae = function Ae(e, t) {
      return function (n) {
        return n === e ? t : n < e && n < t || n > e && n > t ? n : t > e ? n - 1 : t < e ? n + 1 : n;
      };
    };

    var ze = function ze(e, t) {
      return Object.keys(e).map(function (e, n) {
        var o = Te(e);
        return We(o, function (o) {
          return t(e, o, n);
        });
      }).reduce(function (e, t) {
        return t(e);
      }, e);
    },
        Fe = function Fe(e) {
      var t = Object.entries(e),
          _ref29 = t.filter(function (_ref31) {
        var _ref32 = _slicedToArray(_ref31, 2),
            e = _ref32[1];

        return "open" === e.visibility;
      }).sort(function (_ref33, _ref34) {
        var _ref35 = _slicedToArray(_ref33, 2),
            e = _ref35[1];

        var _ref36 = _slicedToArray(_ref34, 2),
            t = _ref36[1];

        return e.order - t.order;
      }).pop() || [],
          _ref30 = _slicedToArray(_ref29, 1),
          n = _ref30[0];

      return n;
    },
        Pe = function Pe(e, t, n) {
      return _objectSpread(_objectSpread({
        position: {
          top: 50 + 50 * n,
          left: 200 + 100 * n
        },
        visibility: "closed"
      }, t), {}, {
        order: n + 1
      });
    },
        Ze = function Ze(e) {
      return ze(e, Pe);
    },
        Be = function Be(e, t) {
      return t.type.startsWith("window.") ? Ge(e, t) : t.type.startsWith("top.") ? He(e, t) : e;
    },
        He = function He(e, _ref37) {
      var t = _ref37.type,
          n = _ref37.id,
          o = _ref37.window,
          r = _ref37.newState;
      var i = Te(n);

      switch (t) {
        case "top.create":
          {
            var _t = Object.keys(e).length,
                _n = function (e) {
              var t = Fe(e) || -1,
                  n = Te(t, "position").get(e);
              return n ? {
                left: n.left + 40,
                top: n.top + 20
              } : {
                left: 200,
                top: 100
              };
            }(e),
                _r = Pe(0, _objectSpread({
              position: _n
            }, o), _t);

            return i.set(e, _r);
          }

        case "top.destroy":
          {
            var _t2 = _objectSpread({}, e);

            return delete _t2[n], _t2;
          }

        case "top.focusNext":
          {
            var _t3 = Fe(e);

            return _t3 ? Te(_t3, "isFocused").set(e, !0) : e;
          }

        case "top.reset":
          return Ze(r);
      }
    },
        Ge = function Ge(e, _ref38) {
      var t = _ref38.type,
          n = _ref38.id,
          o = _ref38.position;
      var r = Te(n, "visibility"),
          i = Te(n, "position"),
          a = Te(n, "isFocused");

      switch (t) {
        case "window.open":
          return r.set(e, "open");

        case "window.minimize":
          return r.set(e, "minimized");

        case "window.close":
          return r.set(e, "closed");

        case "window.focus":
          return a.set(e, !0);

        case "window.blur":
          return a.set(e, !1);

        case "window.move":
          return We(i, function (e) {
            return _objectSpread(_objectSpread({}, e), o);
          })(e);

        case "window.bringToFront":
          return function (e, t) {
            return function (n) {
              var o = We(Te("order"), Ae(e, t));
              return ze(n, function (e, t) {
                return o(t);
              });
            };
          }(e[n].order, Object.keys(e).length)(e);
      }
    },
        Ue = function Ue(e) {
      var _Object15 = Object(o.useReducer)(Be, e, Ze),
          _Object16 = _slicedToArray(_Object15, 2),
          t = _Object16[0],
          n = _Object16[1],
          r = function r(e) {
        return {
          open: function open() {
            n({
              type: "window.open",
              id: e
            }), n({
              type: "window.bringToFront",
              id: e
            }), n({
              type: "window.focus",
              id: e
            });
          },
          focus: function focus() {
            n({
              type: "window.bringToFront",
              id: e
            }), n({
              type: "window.focus",
              id: e
            });
          },
          close: function close() {
            n({
              type: "window.close",
              id: e
            }), n({
              type: "window.blur",
              id: e
            }), n({
              type: "top.focusNext"
            });
          },
          minimize: function minimize() {
            n({
              type: "window.minimize",
              id: e
            }), n({
              type: "top.focusNext"
            });
          },
          blur: function blur() {
            return n({
              type: "window.blur",
              id: e
            });
          },
          move: function move(t) {
            return n({
              type: "window.move",
              id: e,
              position: t
            });
          }
        };
      },
          i = function i(e, o) {
        void 0 === t[e] && n({
          type: "top.create",
          id: e,
          window: o
        });
      },
          a = Object.keys(t).length,
          s = {
        createWindow: i,
        destroyWindow: function destroyWindow(e) {
          void 0 !== t[e] && (n({
            type: "top.destroy",
            id: e
          }), n({
            type: "top.focusNext"
          }));
        },
        openWindow: function () {
          var _openWindow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e, n) {
            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    void 0 === t[e] ? (i(e, n), setTimeout(function () {
                      r(e).open();
                    }, 0)) : r(e).open();

                  case 1:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          }));

          function openWindow(_x11, _x12) {
            return _openWindow.apply(this, arguments);
          }

          return openWindow;
        }(),
        closeWindow: function closeWindow(e) {
          void 0 !== t[e] && r(e).close();
        },
        reset: function reset(e) {
          n({
            type: "top.reset",
            newState: e
          });
        },
        window: Object(o.useMemo)(function () {
          return ze(t, r);
        }, [a])
      };

      return [t, s];
    };
  }]);
});